import getMapData from "./component-library466.mjs";
function mapCacheDelete(key) {
  var result = getMapData(this, key)["delete"](key);
  this.size -= result ? 1 : 0;
  return result;
}
export {
  mapCacheDelete as default
};
